import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { CopySourceAdapter, commonCopySourceAdapts } from 'app/model/adapters/activities/copysource/copysource.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { OracleFusionCopySource } from 'app/model/pipeline/copysource/oracle-fusion.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleFusionCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        biccSavedJobLabel: '*'
    }
})
export class OracleFusionCopySourceAdapter extends CopySourceAdapter<OracleFusionCopySource, Model.CopySource> {
    protected async _toResource(copySource: OracleFusionCopySource): Promise<Model.CopySource> {
        const resource = this.getCommonCopySourceProperties(copySource, OracleFusionCopySource.MODEL.name);
        resource.biccSavedJobLabel = ValueAdapter.toResource(copySource, OracleFusionCopySource.BICC_SAVED_JOB_LABEL);
        return resource;
    }

    protected async _toModel(resource: Model.CopySource, copyActivity: CopyActivity): Promise<OracleFusionCopySource> {
        const source = this.createCopySourceWithCommonProperties(
            OracleFusionCopySource.MODEL,
            resource,
            copyActivity
        ) as OracleFusionCopySource;
        ValueAdapter.toModel(source, OracleFusionCopySource.BICC_SAVED_JOB_LABEL, resource.biccSavedJobLabel);
        return source;
    }
}